const UserTypes = {
    SET_USER: 'SET_USER',
    REMOVE_USER: 'REMOVE_USER',
    SET_IS_DEMO: 'SET_IS_DEMO',
    GET_TOKEN: 'GET_TOKEN',
    SET_IOS_ANDROID: 'SET_IOS_ANDROID',
    SEE_PWA_INFO: 'SEE_PWA_INFO'
};

export default UserTypes;